'use client';

import { Storytelling } from '@/app/components/client';
import type { DatoBlock, DatoModuleFormat } from '@/lib/datocms';

import type { FlexProps } from '@ironhack/design-system2';
import type { ReactElement } from 'react';

export type Header = DatoBlock<{
  description: string;
  title: string;
}>;

type Props = { data: Header } & FlexProps;

export const Header = (props: Props): ReactElement => {
  const { data, ...flexProps } = props;
  const { description, title } = data;

  const moduleFormat: [DatoModuleFormat] = [
    { background: 'transparent', spacingBottom: '80', spacingTop: '40' },
  ];
  const storytellingData = {
    columns: [{ title, subtitle: description }, {}],
    headingProps: { as: 'h1' as const },
    moduleFormat,
  };

  return <Storytelling data={storytellingData} {...flexProps} />;
};
